/**
 * 安全配置 - 修改导航组件
*/


import CNF from '../../incs/Config.js';
import { DeleteCookies } from '../../incs/FunHelper';
import Logo from '../../images/logo.png';
import { Row, Col, Button, Typography } from 'antd';

const { Text } = Typography;

const SecurityUpdateNav = (props) => {
    return (
        <>
            <Row style={{
                backgroundColor: '#001529',
                color: '#FFFFFF',
                height: '64px',
                lineHeight: '64px',

            }}>
                <Col span={3} offset={5}>
                    <a href={CNF.userUrl}>
                        <img src={Logo} style={{ height: '40px', marginTop: '12px' }} alt='' />
                    </a>
                </Col>
                <Col span={6}><Text style={{ color: '#FFFFFF', }} strong>{props.title}</Text></Col>
                <Col span={3}>
                    <span>您好，{props.username} </span>
                    <span style={{ float: 'right' }}>|</span>
                </Col>
                <Col span={1} style={{ textAlign: 'center', }}>
                    <Button type='link' style={{ color: '#FFFFFF' }} href={CNF.userUrl}>返回</Button>
                </Col>
                <Col span={1} style={{ textAlign: 'center', }}>
                    <Button type='link' style={{ color: '#FFFFFF' }} onClick={(e) => {
                        e.preventDefault();
                        DeleteCookies();
                    }}>退出</Button>
                </Col>
                <Col span={1} style={{ textAlign: 'center', }}>
                    <Button type='link' style={{ color: '#FFFFFF' }}>帮助</Button>
                </Col>
            </Row>
        </>
    );
}

export default SecurityUpdateNav;